export enum Role {
  ADMIN = 'ADMIN',
  UTILISATEUR = 'UTILISATEUR',
  /**
   * Compte **technique**, pas une personne : « Alertes Qualité » signe les
   * non-conformités ouvertes automatiquement, et d'autres suivront. Il doit
   * pouvoir s'AFFICHER (c'est l'auteur d'une alerte) mais ne jamais être
   * PROPOSÉ dans un sélecteur — on ne lui assigne pas une tâche.
   * Cf. `UiFacadeService.selectableUserInfos`.
   */
  API = 'API',
}

